export default __webpack_public_path__ + "static/media/Banner@2x.d65f31eb.jpg";